import { render, staticRenderFns } from "./ExpenseComponent.vue?vue&type=template&id=066d420b&scoped=true&"
import script from "./ExpenseComponent.vue?vue&type=script&lang=js&"
export * from "./ExpenseComponent.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseComponent.vue?vue&type=style&index=0&id=066d420b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066d420b",
  null
  
)

export default component.exports